<template>

  <svg
    t="1639124202823"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3965"
    width="64"
    height="64"
  ><path d="M149.45117213 281.28710912l362.54882787-164.79492162 362.54882787 164.79492162 0 461.425781-362.54882787 164.7949216-362.54882787-164.7949216 0-461.425781zM479.04101537 467.20874023l-263.67187475-119.73999023 0 352.76000951 263.67187475 120.00366186 0-353.0236819zM808.63085938 700.22875951l-1e-8-352.76000951-263.67187474 119.73999023 0 353.0236819zM755.07251002 299.31567383l-243.07251002-110.47851588-243.07251002 110.47851588 243.07251002 110.47851588z" p-id="3966" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconBox',
} as DefineComponent
</script>